import React from 'react'
import { useHistory } from 'react-router'
import { BannerList } from '../components/BannerList'

export const HomeScreenBannersList = () => {
  const history = useHistory()

  const handleEdit = (bannerId: string) => {
    history.push(`/home-screen-banner/${bannerId}`)
  }

  const handleCreate = () => {
    history.push('/home-screen-banner/create')
  }

  return (
    <BannerList
      onEdit={handleEdit}
      onCreate={handleCreate}
    />
  )
}